import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environement';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { SuiviResponseDTO } from '../../../models/SuiviResponseDTO';
import { SuiviRequestDTO } from '../../../models/SuiviRequestDTO';

@Injectable({
  providedIn: 'root'
})
export class SuiviService {
  baseUrl = environment.apiUrl + '/api/suivis';

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private getAuthHeaders(): { [header: string]: string } {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('presence');
      return token ? { Authorization: `Bearer ${token}` } : {};
    }
    return {};
  }


  createSuivi(eleveId: number, formateurId: number, dto: SuiviRequestDTO): Observable<SuiviResponseDTO> {
    return this.http.post<SuiviResponseDTO>(`${this.baseUrl}/${eleveId}/${formateurId}`, dto, { headers: this.getAuthHeaders() });
  }

  getSuivisByEleveId(eleveId: number): Observable<SuiviResponseDTO[]> {
    return this.http.get<SuiviResponseDTO[]>(`${this.baseUrl}/eleve/${eleveId}`, { headers: this.getAuthHeaders() });
  }

  getLastSuiviByEleveId(eleveId: number): Observable<SuiviResponseDTO> {
    return this.http.get<SuiviResponseDTO>(`${this.baseUrl}/lastByEleveId?eleveId=${eleveId}`, { headers: this.getAuthHeaders() });
  }

  getSuiviById(id: number): Observable<SuiviResponseDTO> {
    return this.http.get<SuiviResponseDTO>(`${this.baseUrl}/${id}`, { headers: this.getAuthHeaders() });
  }

  getAllSuivis(): Observable<SuiviResponseDTO[]> {
    return this.http.get<SuiviResponseDTO[]>(this.baseUrl, { headers: this.getAuthHeaders() });
  }

  updateSuivi(id: number, dto: SuiviRequestDTO): Observable<SuiviResponseDTO> {
    return this.http.put<SuiviResponseDTO>(`${this.baseUrl}/${id}`, dto, { headers: this.getAuthHeaders() });
  }

  deleteSuivi(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, { headers: this.getAuthHeaders() });
  }

  getSuivisByParentId(parentId: number): Observable<SuiviResponseDTO[]> {
    return this.http.get<SuiviResponseDTO[]>(`${this.baseUrl}/parent/${parentId}`, { headers: this.getAuthHeaders() });
  }

  getSuiviByDateAndEleveId(date: string, eleveId: number): Observable<SuiviResponseDTO> {
    return this.http.get<SuiviResponseDTO>(`${this.baseUrl}/suiviByEleveAndDate?date=${date}&eleveId=${eleveId}`, { headers: this.getAuthHeaders() });
  }
} 
  

